 import React from 'react';
 import GeneralRecs from '../components/GeneralRecs';

const Home = () => {
  return (
    <div>
        <GeneralRecs />
    </div>
  )
}

export default Home